<div #lineElement
  (click)="changeStyleOnMouseHover($event, line)"
  (mouseleave)="changeStyleOnMouseHover($event, line)"
  (mouseover)="changeStyleOnMouseHover($event, line)"
  [attr.class]="tableLineClass"
     [ngClass]="{
     'table-line-no-expandable-lines': !expandableLine,
     'has-float-content' : retrieveFloatContent
     }"
  data-cy="table-line">

  <app-tooltip [disable]="disableFullLineTooltip()"
    [dynamic]="false"
    [manualClose]="closeFullLineTooltipEmitter"
    [manualOpen]="openFullLineTooltipEmitter"
    [message]="fullLineTooltipText"
    placement="top-left">

    <div (click)="toggleAccordion()"
      [attr.class]="tableRowClass"
             [ngClass]="{
                'table-line-available-actions-no-expandable-lines': hasTableLineAvailableActions,
                'table-line-isHighlight': hasHighlight
             }"
      [ngStyle]="tableRowGridStyle"
      data-cy="table-row">

      <div class="table-line-expand-button-wrapper"
        [ngClass]="{'table-line-expand-button-wrapper-no-expandable-lines': hasTableLineAvailableActions()}">
        @if (expandableLine) {
          <span [attr.class]="accordionButtonClass" data-cy="table-line-expand-button"></span>
        }
        <div class="table-line-animation {{animationCssClass}}"
          [ngClass]="{'table-line-animation-no-expandable-lines': !expandableLine}"
        data-cy="table-line-animation"></div>
      </div>

      <div [ngStyle]="columnStyles">
        @for (opt of line.data | keyvalue: originalOrder; track opt) {
          @if (showColumn(opt.key)) {
            <!-- Entry value with a TemplateRef -->
            @if (cellHasTemplateRef(opt.value.cellValue)) {
              <span [ngClass]="{'has-float-content' : attributeHasFloatContent(opt.key)}"
                data-cy="table-line-entry">
                <ng-template [ngTemplateOutletContext]="embedAccordionProprieties(opt.value.cellValue.context)"
                [ngTemplateOutlet]="opt.value.cellValue.templateRef"></ng-template>
              </span>
            } @else {
              @if (attributeHasPipe(opt.key)) {
                <div [ngClass]="{'cell-align-right' : attributeHasTextAlignRight(opt.key)}"
                  class="pipe-border">
                  @if (attributeHasCopyPaste(opt.key)) {
                    <app-copy-paste
                      [copyText]="opt.value.copyPasteValue != null ? opt.value.copyPasteValue : applyAttributePipe(opt.key, opt.value.cellValue)"
                      [backgroundColor]="backgroundColorHover"
                      [buttonAlignRight]="attributeHasTextAlignRight(opt.key)">
                      <app-tooltip (hidden)="openFullLineTooltip()"
                        (shown)="closeFullLineTooltip()"
                        [attr.data-cy]="getDataCyTableLine(opt.key)"
                        [message]="applyAttributePipe(opt.key, opt.value.cellValue)">
                        @if (attributeHasDot(opt.key)) {
                          <app-status-dot [ngClass]="getDotClass(opt.value.dotClass)"
                          data-cy="table-line-entry-dot"></app-status-dot>
                        }
                        <span class="table-line-entry"
                          data-cy="table-line-entry">{{applyAttributePipe(opt.key,
                        opt.value.cellValue) | undefinedValue }}</span>
                      </app-tooltip>
                    </app-copy-paste>
                  } @else {
                    <app-tooltip (hidden)="openFullLineTooltip()"
                      (shown)="closeFullLineTooltip()"
                      [attr.data-cy]="getDataCyTableLine(opt.key)"
                      [message]="applyAttributePipe(opt.key, opt.value.cellValue)">
                      @if (attributeHasDot(opt.key)) {
                        <app-status-dot [ngClass]="getDotClass(opt.value.dotClass)"
                        data-cy="table-line-entry-dot"></app-status-dot>
                      }
                      <span class="table-line-entry"
                        data-cy="table-line-entry">{{applyAttributePipe(opt.key,
                      opt.value.cellValue) | undefinedValue }}</span>
                    </app-tooltip>
                  }
                </div>
              } @else {
                <div [ngClass]="{'cell-align-right' : attributeHasTextAlignRight(opt.key)}"
                  class="pipe-border">
                  @if (attributeHasCopyPaste(opt.key)) {
                    <app-copy-paste
                      [copyText]="opt.value.cellValue"
                      [backgroundColor]="backgroundColorHover"
                      [buttonAlignRight]="attributeHasTextAlignRight(opt.key)">
                      <app-tooltip (hidden)="openFullLineTooltip()"
                        (shown)="closeFullLineTooltip()"
                        [attr.data-cy]="getDataCyTableLine(opt.key)"
                        [message]="opt.value.cellValue">
                        @if (attributeHasDot(opt.key)) {
                          <app-status-dot [ngClass]="getDotClass(opt.value.dotClass)"
                          data-cy="table-line-entry-dot"></app-status-dot>
                        }
                        <span class="table-line-entry"
                        data-cy="table-line-entry">{{opt.value.cellValue}}</span>
                      </app-tooltip>
                    </app-copy-paste>
                  } @else {
                    <app-tooltip (hidden)="openFullLineTooltip()"
                      (shown)="closeFullLineTooltip()"
                      [attr.data-cy]="getDataCyTableLine(opt.key)"
                      [message]="opt.value.cellValue">
                      @if (attributeHasDot(opt.key)) {
                        <app-status-dot [ngClass]="getDotClass(opt.value.dotClass)"
                        data-cy="table-line-entry-dot"></app-status-dot>
                      }
                      <span class="table-line-entry"
                      data-cy="table-line-entry">{{opt.value.cellValue}}</span>
                    </app-tooltip>
                  }
                </div>
              }
            }
            <!-- Entry value with an applied pipe -->
            <!-- Entry value with no pipe -->
          } @else {
            <div class="hide-column"></div>
          }
        }
      </div>
      <div class="table-context-menu"></div>
      @if (hasLineMouseHoverAndAvailableActions) {
        <div class="table-line-available-action-wrapper">
          <div class="table-line-available-action-icons-wrapper">
            @if (this.lineAvailableActions?.includes(TableAvailableActionsEnum.EDIT)) {
              <span
                class="iwp-icon-gen_edit_doc" data-cy="table-line-available-action-edit"
              (click)="emitAvailableAction(TableAvailableActionsEnum.EDIT, line.identifier)"></span>
            }
            @if (this.lineAvailableActions?.includes(TableAvailableActionsEnum.VIEW)) {
              <span
                class="iwp-icon-gen_show_all" data-cy="table-line-available-action-view"
              (click)="emitAvailableAction(TableAvailableActionsEnum.VIEW, line.identifier)"></span>
            }
            @if (this.lineAvailableActions?.includes(TableAvailableActionsEnum.DELETE)) {
              <span
                class="iwp-icon-gen_delete" data-cy="table-line-available-action-delete"
              (click)="emitAvailableAction(TableAvailableActionsEnum.DELETE, line.identifier)"></span>
            }
          </div>
        </div>
      }
    </div>
  </app-tooltip>
  @if (line?.isOpen) {
    <div class="table-line-opened-border-bottom"></div>
  }
</div>

@if (lineIsSelected) {
  <div #accordionContainer [ngClass]="{'min-height': line.accordionData == null, 'isHoverLine': applyMouseHover}"
    class="table-line-accordion"
    [ngStyle]="lineAccordionPadding"
    [id]="line.identifier">
    <div class="table-line-accordion-spinner">
      @if (line.accordionData == null) {
        <app-loading-spinner></app-loading-spinner>
      }
    </div>
    @if (line.accordionData != null) {
      <ng-container
      *ngTemplateOutlet="accordionLineTemplate; context: {context: line.accordionData}"></ng-container>
    }
  </div>
}

@if (line.borderColorIdentification) {
  <div
    [ngClass]="line.borderColorIdentification" class="status-left-border"
    data-cy="status-left-border">
  </div>
}

@if (line?.hasFlag) {
  <div class="table-line-flag" data-cy="table-line-flag">
    <app-flag [configuration]="$safeNavigationMigration(line?.flagConfiguration)"></app-flag>
  </div>
}

